import {useEffect, useState} from "react";

const PAGE_SIZE = 10;

export default (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [activities, setActivities] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);



    const [mode, setMode] = useState("TOM"); // TOM or USDT
    const [amount, setAmount] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const [cardSheba, setSheba] = useState("");
    const [cardHesab, setHesab] = useState("");
    const [cardName, setName] = useState("");
    const [bankName, setBankName] = useState("");
    const [walletAddress, setWalletAddress] = useState("");

    const fetchActivities = async (page) => {
        setLoading(true);
        try {

            const res = props.ctx.ajax(window.config.api + "/profile/all_sell/" + page, {
                authToken: props.ctx.auth
            }).then(function (data) {
                setActivities(data || []);
                setTotalPages(5);
            })

        } catch (e) {
            console.error("خطا در دریافت اطلاعات:", e);
        } finally {
            setLoading(false);
        }
    };
    const handleWithdraw = async () => {
        if (!amount || isNaN(amount)) {
            props.ctx._notif('error' , "مبلغ معتبر وارد کنید.")
            return;
        }

        const payload = {
            mode,
            amount,
            ...(mode === "TOM"
                ? {
                    sourceCart: cardNumber,
                    sourceBank: bankName,
                    sourceSheba: cardSheba,
                    sourceHesab: cardHesab,
                    sourceName: cardName,
                    authToken: props.ctx.auth,
                }
                : {
                    wallet: walletAddress,
                    authToken: props.ctx.auth,
                }),
        };

        try {
            const result = await props.ctx.ajax(
                window.config.api + "/profile/request_withdraw/"+mode+'/'+amount, payload
            ).then(function (res) {

                if(res && res.status ){
                    props.ctx._notif(res.status , res.message)

                    fetchActivities(currentPage);
                }
                else{
                    props.ctx._notif('error' , "خطا در ثبت اطلاعات. لطفاً دوباره تلاش کنید.")
                }

            })


        } catch (e) {
            console.error(e);
            props.ctx._notif('error' , "خطا در ثبت اطلاعات. لطفاً دوباره تلاش کنید.")
        }
    };
    useEffect(() => {
        fetchActivities(currentPage);
    }, [currentPage]);

    const renderStatus = (status) => {
        switch (status) {
            case 0:
                return "در انتظار بررسی";
            case 1:
                return "تایید شده";
            case 2:
                return "رد شده";
            default:
                return "نامشخص";
        }
    };

    return (
        <div className="container mt-4 mb-4">
            <h5 className="mb-4">برداشت های من</h5>

            <div className="row g-3 mb-4">

                <div className="col-md-6">
                    <div className="card text-center">
                        <div className="card-body">
                            <h5 className="card-title">بالانس ریالی
                            </h5>
                            <p className="card-text text-success">
                                {props.ctx.addCommos(props.ctx.profile.balance, 2)} تومان
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card text-center">
                        <div className="card-body">
                            <h5 className="card-title">
                                بالانس دلاری
                            </h5>
                            <p className="card-text text-primary">
                                ${props.ctx.addCommos(props.ctx.profile.usd_balance, 2)}
                            </p>

                        </div>
                    </div>
                </div>
            </div>



            <div className="card mb-4">
                <div className="card-body">
                    <h6 className="mb-3">درخواست برداشت جدید</h6>

                    <div className="mb-3">
                        <label className="form-label">نوع برداشت</label>
                        <select
                            className="form-select"
                            value={mode}
                            onChange={(e) => setMode(e.target.value)}
                        >
                            <option value="TOM">برداشت ریالی</option>
                            <option value="USDT">برداشت دلاری (USDT)</option>
                        </select>
                    </div>

                    <div className="mb-3">
                        <label className="form-label">مبلغ</label>
                        <input

                            className="form-control"
                            value={props.ctx.addCommos(amount , 2)}
                            onChange={(e) => setAmount(parseFloat(props.ctx.removeCommos(e.target.value)))}
                        />
                    </div>

                    {mode === "TOM" && (
                        <>
                            <div className="mb-3">
                                <label className="form-label">شماره کارت</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={cardNumber}
                                    onChange={(e) => setCardNumber(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">شماره شبا</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={cardSheba}
                                    onChange={(e) => setSheba(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">شماره حساب</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={cardHesab}
                                    onChange={(e) => setHesab(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">صاحب حساب</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={cardName}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">نام بانک</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={bankName}
                                    onChange={(e) => setBankName(e.target.value)}
                                />
                            </div>
                        </>
                    )}

                    {mode === "USDT" && (
                        <div className="mb-3">
                            <label className="form-label">آدرس ولت</label>
                            <input
                                type="text"
                                className="form-control"
                                value={walletAddress}
                                onChange={(e) => setWalletAddress(e.target.value)}
                            />
                        </div>
                    )}

                    <button className="btn btn-success" onClick={handleWithdraw}>
                        ثبت درخواست برداشت
                    </button>
                </div>
            </div>




            {activities.length === 0 ? (
                <p className="text-muted mt-4">هیچ برداشت ای ثبت نشده است.</p>
            ) : (
                <>
                    <div className="table-responsive mt-4">
                        <table className="table table-bordered text-center align-middle">
                            <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>نوع</th>
                                <th>مبلغ</th>
                                <th>تاریخ</th>
                                <th>وضعیت</th>
                                <th>جزئیات</th>
                            </tr>
                            </thead>
                            <tbody>
                            {activities.map((item, idx) => (
                                <tr key={item.id}>
                                    <td>{(currentPage - 1) * PAGE_SIZE + idx + 1}</td>
                                    <td>{item.mode}</td>
                                    <td>{item.amount.toLocaleString()} {item.mode === "TOM" ? "تومان" : "تتر"}</td>
                                    <td>{new Date(item.timestamp * 1000).toLocaleString("fa-IR")}</td>
                                    <td>{renderStatus(item.status)}</td>
                                    <td>
                                        {item.mode === "TOM" ? (
                                            <>
                                                <div><strong>کارت:</strong> {item.sourceCart || "ثبت نشده"}</div>
                                                <div><strong>بانک:</strong> {item.sourceBank || "ثبت نشده"}</div>
                                            </>
                                        ) : (
                                            <>
                                                <div><strong>از ولت:</strong> {item.fromWallet || "ثبت نشده"}</div>
                                                <div><strong>به ولت:</strong> {item.toWallet || "ثبت نشده"}</div>
                                                <div><strong>هش:</strong> {item.hashPay || "ثبت نشده"}</div>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}

                </>
            )}
            <nav>
                <ul className="pagination justify-content-center mt-3">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                            className="page-link"
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            قبلی
                        </button>
                    </li>

                    <li className="page-item   active">
                                <span className="page-link">
                                    صفحه {currentPage}
                                </span>
                    </li>

                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                            className="page-link"
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        >
                            بعدی
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );
};
